import { setToken, getToken, removeToken } from "@/utils/util";
import { login, logout, getUserInfo } from "@/api/user";
let myHomeCloudId = "15"; //我家云的模块id, 固定值，用来判断是否是我家云客户
export default {
  state: {
    name: "",
    avatar: "",
    userId: "",
    professional: "", //专业名称
    mobile: "", //手机号
    gender: "", //性别 1男 2女
    access: "", //账号
    post: "", //职务
    department: "", //部门
    role: "", //角色
    token: getToken(),
    hasGetInfo: false,
    permissionList: [],
    currentProjectId: "",
    isMyHomeCloud: false //是否是我家云客户
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      setToken(token);
    },
    removeToken(state) {
      state.token = "";
      removeToken();
    },
    setUserName(state, userName) {
      state.name = userName;
    },
    setAvatar(state, avatar) {
      state.avatar = avatar;
    },
    setGender(state, gender) {
      state.gender = Number(gender);
    },
    setPost(state, post) {
      state.post = post;
    },
    setAccess(state, access) {
      state.access = access;
    },
    setDepartment(state, department) {
      state.department = department;
    },
    setMobile(state, mobile) {
      state.mobile = mobile;
    },
    setRole(state, role) {
      state.role = role;
    },
    setProfessional(state, professional) {
      state.professional = professional;
    },
    setUserId(state, userId) {
      state.userId = userId;
    },
    setOutUserId(state, userId) {
      state.outUserId = userId;
    },
    setCurrentProjectId(state, projectId) {
      state.currentProjectId = projectId;
    },
    setPermissionList(state, accessList) {
      state.isMyHomeCloud = accessList.indexOf(myHomeCloudId) !== -1;
      state.permissionList = accessList;
    },
    setHasGetInfo(state, status) {
      state.hasGetInfo = status;
    }
  },
  getters: {
    token: state => state.token,
    userName: state => state.name,
    isMyHomeCloud: state => state.isMyHomeCloud,
    userInfo: state => {
      return {
        uid: state.userId,
        name: state.name,
        avatar: state.avatar,
        mobile: state.mobile,
        gender: state.gender,
        access: state.access,
        post: state.post,
        department: state.department,
        role: state.role
      }
    },
    permissionList: state => state.permissionList,
    currentProjectId: state => state.currentProjectId
  },
  actions: {
    handleLogin({ commit }, { username, password }) {
      username = username.trim();
      return new Promise((resolve, reject) => {
        login({
          username,
          password
        })
          .then(res => {
            let token = res.token;
            commit("setToken", token);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    handleLogout({ commit }) {
      return new Promise((resolve, reject) => {
        logout()
          .then(res => {
            commit("removeToken");
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // getUserInfo({ commit }) {
    //   return new Promise((resolve, reject) => {
    //     getUserInfo()
    //       .then(res => {
    //         commit("setOutUserId", res.out_userid);
    //         commit("setUserName", res.name);
    //         commit("setAvatar", res.head_pic);
    //         commit("setGender", res.gender);
    //         commit("setAccess", res.username);
    //         commit("setProfessional", res.subgroup_names);
    //         commit("setPost", res.duty_name);
    //         commit("setDepartment", res.department_name);
    //         commit("setMobile", res.mobile);
    //         commit("setRole", res.role_name);
    //         commit("setUserId", res.id);
    //         commit("setPermissionList", res.power);
    //         commit("setHasGetInfo", true);
    //         commit("setCurrentProjectId", res.shop_id);
    //         resolve(res);
    //       })
    //       .catch(err => {
    //         reject(err);
    //       });
    //   });
    // },
    reloadProject({ commit }, { token, projectId }) {
      commit("setToken", token);
      commit("setCurrentProjectId", projectId);
    },
    resetToken({ commit }) {
      return new Promise(resolve => {
        commit("setToken", "");
        commit("setPermissionList", []);
        removeToken();
        resolve();
      });
    }
  }
};
